import React from 'react';
import { createPortal } from 'react-dom';
import { TypedMemo } from '../../../common/types';
import { PaletteDialog } from './PaletteDialog';

interface CommandPaletteProps {
  isOpen: boolean;
  onClose: () => void;
}

/**
 * The command palette, the search of the app (⌘K, "/", the sidebar search field; design
 * navigation-v2 e 5d). The dialog mounts on each open, so it opens with an empty text.
 */
const CommandPaletteComponent: React.FC<CommandPaletteProps> = ({ isOpen, onClose }) => {
  if (!isOpen || typeof document === 'undefined') {
    return null;
  }
  return createPortal(<PaletteDialog onClose={onClose} />, document.body);
};

export const CommandPalette = TypedMemo(CommandPaletteComponent);
